module.exports = __webpack_public_path__ + "v2/201912030311910/img/tail-spin.31015385.svg";